var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149830",
    "data-name": "Group 149830",
    transform: "translate(-187 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102508",
    "data-name": "Path 102508",
    d: "M96.725,90.25a6.475,6.475,0,1,0,6.475,6.475A6.482,6.482,0,0,0,96.725,90.25Zm2.921,6.475-2.921,2.921L93.8,96.725,96.725,93.8Z",
    transform: "translate(100.275 165.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102509",
    "data-name": "Path 102509",
    d: "M17.071,2.929A10,10,0,0,0,2.929,17.071,10,10,0,0,0,17.071,2.929ZM10,17.646A7.646,7.646,0,1,1,17.646,10,7.655,7.655,0,0,1,10,17.646Z",
    transform: "translate(187 252)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot);
export default __webpack_public_path__ + "static/media/spot.f1495fd0a0c7b5a76a5f5e8b4615276f.svg";
export { ForwardRef as ReactComponent };